// Upload-Helfer (Browser): Handyfotos vorab verkleinern — spart Upload-Zeit und hält uns
// unter dem Proxy-Limit. Klappt das Dekodieren nicht (z. B. HEIC in Chrome), geht das
// Original hoch und das Backend meldet sich mit Klartext.
const MAX_KANTE = 2400;

export async function verkleinereBild(datei: File): Promise<File> {
  if (!datei.type.startsWith('image/') || datei.size < 1_500_000) return datei;
  try {
    const bmp = await createImageBitmap(datei);
    const f = Math.min(1, MAX_KANTE / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bmp.width * f);
    canvas.height = Math.round(bmp.height * f);
    canvas.getContext('2d')!.drawImage(bmp, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((r) => canvas.toBlob(r, 'image/jpeg', 0.88));
    if (!blob) return datei;
    return new File([blob], datei.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return datei;
  }
}

/** Fehlermeldung aus axios-Fehler, auch wenn die Antwort als Blob kam. */
export async function fehlerText(e: any, fallback: string): Promise<string> {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.error?.message ?? fallback;
    } catch {
      return fallback;
    }
  }
  if (e?.response?.status === 413) return 'Datei zu groß für den Upload.';
  return data?.error?.message ?? data?.message ?? e?.message ?? fallback;
}
